import {
    InterpretationActionTypes,
    InterpretationIdentifiers,
    InterpretationState,
} from "#store/interpretations/interpretationTypes";
import { IoStateEnum } from "#store/types";
import { isEmpty } from "#types";

/*******************************************************************************
 * Reducer related stuff
 ******************************************************************************/

const initialState: InterpretationState = {
    interpretations: {},
};

// The reducer function
export function interpretationsReducer(
    state = initialState,
    action: InterpretationActionTypes
): InterpretationState {
    switch (action.type) {
        case InterpretationIdentifiers.FETCH_FROM_SERVER_STARTED: {
            if (isEmpty(state.interpretations[action.payload])) {
                return {
                    ...state,
                    interpretations: {
                        ...state.interpretations,
                        [action.payload]: {
                            payload: null,
                            state: IoStateEnum.fetching,
                            error: null,
                            timestamp: new Date(),
                        },
                    },
                };
            } else {
                return state;
            }
        }
        case InterpretationIdentifiers.FETCH_FROM_SERVER_SUCCEEDED: {
            return {
                ...state,
                interpretations: {
                    ...state.interpretations,
                    [action.payload.id]: {
                        payload: action.payload,
                        state: IoStateEnum.done,
                        error: null,
                        timestamp: new Date(),
                    },
                },
            };
        }
        case InterpretationIdentifiers.FETCH_FROM_SERVER_FAILED: {
            return {
                ...state,
                interpretations: {
                    ...state.interpretations,
                    [action.payload.id]: {
                        payload: null,
                        error: action.payload,
                        timestamp: new Date(),
                        state: IoStateEnum.error,
                    },
                },
            };
        }
        default: {
            return state;
        }
    }
}
